module.exports = __webpack_public_path__ + "img/icon_bet.611a179d.svg";